import React, { FC, useContext, useMemo } from 'react';
import styles from './Annotation.module.scss';
import Breadcrumb from './Breadcrumb/Breadcrumb';
import { connect } from 'react-redux';
import { RootState } from '../../../rootReducer';
import { AppDispatch } from '../../../store';
import SelectedNode from './SelectedNode';
import { ParserContext } from '../contexts/ParserContext';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';

type Props = {
  hideStichedView: boolean;
  hideTree: boolean;
  treeWidth: number;
  setHideStichedView: (value: boolean) => void;
};

type StoreProps = ReturnType<typeof mapStateToProps>;

const SelectedNodeContainer: FC<RouteComponentProps<any> & Props & StoreProps> = ({
  match,
  hideTree,
  hideStichedView,
  image,
  loaded,
  fullScreenMode,
  treeWidth,
  pathContext,
  showImagesAsTree,
  setHideStichedView
}) => {
  const { parser } = useContext(ParserContext);

  const breadcrumb = useMemo(() => parser.getBreadcrumb(match.params), [match.params, parser]);

  return (
    <div className={styles.mainPanel}>
      <Breadcrumb node={breadcrumb} />
      <SelectedNode
        {...{
          image,
          hideTree,
          hideStichedView,
          loaded,
          fullScreenMode,
          treeWidth,
          setHideStichedView,
          pathContext,
          showImagesAsTree
        }}
      />
    </div>
  );
};

const mapStateToProps = (state: RootState, props: Props) => ({
  image: state.annotation.image,
  fullScreenMode: state.annotation.fullScreenMode,
  loaded: state.canvas.loaded,
  pathContext: state.annotation.pathContext,
  showImagesAsTree: state.annotation.showImageTree,
  ...props
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectedNodeContainer));
